import classNames from "classnames";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

function SidebarLayout(props) {
  const [collapsedStorage, setSidebarCollapsedStorage] = useState('closed');

  useEffect(() => {
  const collapsedSP = sessionStorage.getItem('collapsed');
  if(collapsedSP != null){
    return setSidebarCollapsedStorage(collapsedSP);
  }
  }, [])

  const collapsed = collapsedStorage === 'closed';

  const setSidebarCollapsed = (status) => {
    if(!status){
     sessionStorage.setItem('collapsed', 'open')
     const collapsedStorage = sessionStorage.getItem('collapsed');
    return setSidebarCollapsedStorage(collapsedStorage);
    }
    sessionStorage.setItem('collapsed', 'closed')
    const collapsedStorage = sessionStorage.getItem('collapsed');
    return setSidebarCollapsedStorage(collapsedStorage);
  }

  return (
    <div
      className={classNames({
        "grid min-h-screen": true,
        "grid-cols-sidebar": !collapsed,
        "grid-cols-sidebar-collapsed": collapsed,
        "transition-[grid-template-columns] duration-300 ease-in-out": true,
      })}
      style={{ backgroundColor: "var(--cBranco)"}}
    >
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setSidebarCollapsed}
        shown={true}
      />

      <div>{props.children}</div>
    </div>
  );
}

export default SidebarLayout;
